import {
  fieldDelete,
  fieldDrag,
  fieldImg,
  fieldSetting,
  picturePLaceholder,
  textQuestionIcon,
} from "assets/icons";
import {
  InputAreaAutoAdjust,
  SwitchButton,
  TextArea,
  TextAreaAutoAdjust,
} from "components/form";
import { surveyFormValue } from "constant/staticData";
import React, { useState } from "react";
import { adjustOptions, isArray } from "utils/commonHelper";
import DeleteModal from "components/modals/DeleteModal";
import CustomModal from "components/modals/CustomModal";
import SurveyQuestionSettingValue from "./SurveyQuestionSettingValue";
import UploadImage from "./UploadImage";
import { RxCrossCircled } from "react-icons/rx";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useTranslation } from "react-i18next";

const TextFieldQuestion = ({
  data,
  blockArray,
  indexValue,
  setBlockArray,
  selectedBlock,
  prevQuestionCount,
  surveyQuestionArray,
  setSurveyQuestionArray,
}) => {
  // set all value
  const [deleteQuestionModal, setDeleteQuestionModal] = useState(false);
  const [settingQuestionModal, setSettingQuestionModal] = useState(false);
  const [surveyQuestionImageModal, setSurveyQuestionImageModal] =
    useState(false);

  const { t } = useTranslation();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: data?.questionNumber });

  // const style = {
  //   transform: `translateY(${transform?.y || 0}px)`,
  //   transition,
  // };

  const style = {
    transform: `translateY(${transform?.y || 0}px)`,
    transition,
    opacity: isDragging ? 0.7 : 1, // Change opacity when dragging
    boxShadow: isDragging ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none", // Add shadow when dragging
    cursor: isDragging ? "grabbing" : "grab", // Change cursor style
    background: isDragging ? "#f5f5f5" : "#fff", // Optional: Change background color
  };

  // Optimized onChange handler
  const onChangehandler = (e) => {
    const { name, value } = e?.target || {};
    setSurveyQuestionArray((prevArray) => {
      const updatedArray = { ...prevArray };
      updatedArray[selectedBlock][indexValue][name] = value;
      return updatedArray;
    });
  };

  const onStatusChangehandler = (e) => {
    const { checked } = e?.target || {};
    setSurveyQuestionArray((prevArray) => {
      const updatedArray = { ...prevArray };
      updatedArray[selectedBlock][indexValue]["required"] = checked;
      return updatedArray;
    });
  };

  // close modal
  const closeModal = () => {
    setDeleteQuestionModal(false);
    setSettingQuestionModal(false);
    setSurveyQuestionImageModal(false);
  };

  // handle selected question
  const deletedSelectedQuestionHandler = () => {
    const selectedBlockArray = surveyQuestionArray[selectedBlock];
    if (
      isArray(surveyQuestionArray[selectedBlock]) &&
      Number.isInteger(indexValue) &&
      indexValue >= 0 &&
      indexValue < selectedBlockArray.length
    ) {
      let blockUpdatedClone = blockArray?.map((el) => el);
      let blockIndex = blockArray.findIndex((el) => el?.name === selectedBlock);

      blockUpdatedClone[blockIndex] = {
        ...blockUpdatedClone[blockIndex],
        totalQuestion: blockUpdatedClone[blockIndex]?.totalQuestion - 1,
      };

      setBlockArray(blockUpdatedClone);

      setSurveyQuestionArray((prevSurveyQuestionArray) => {
        const updatedSurveyArray = { ...prevSurveyQuestionArray };
        const updatedBlock = [...selectedBlockArray];
        updatedBlock.splice(indexValue, 1);
        const adjustedSurveyQuestion = adjustOptions(
          "questionNumber",
          updatedBlock
        );
        updatedSurveyArray[selectedBlock] = adjustedSurveyQuestion;
        return updatedSurveyArray;
      });
    }
    closeModal();
  };

  // handle delete Selected Photo handler
  const deletedSelectedPicHandler = () => {
    const selectedBlockArray = surveyQuestionArray[selectedBlock];
    if (
      isArray(surveyQuestionArray[selectedBlock]) &&
      Number.isInteger(indexValue) &&
      indexValue >= 0 &&
      indexValue < selectedBlockArray.length
    ) {
      setSurveyQuestionArray((prevSurveyQuestionArray) => {
        const updatedSurveyArray = { ...prevSurveyQuestionArray };
        const updatedBlock = [...selectedBlockArray];
        updatedBlock[indexValue].questionImage = "";
        updatedSurveyArray[selectedBlock] = updatedBlock;
        return updatedSurveyArray;
      });
    }
  };

  //******************************* Handle HTML CODE *******************************//
  return (
    <>
      <div
        className="fields_wrap"
        ref={setNodeRef}
        // onClick={(e) => e.stopPropagation()}
        style={style}
      >
        <div className="control_section">
          <div className="text">
            <span>
              {" "}
              {data?.questionNumber + prevQuestionCount}
              <img src={textQuestionIcon} alt="" />
            </span>
            <b>
              {t(`CUSTOMIZATION_QUESTION.textChoice`)}
              {/* <font color="red">*</font> */}
            </b>
          </div>
          <div className="control_button">
            <button
              title={t(`CUSTOMIZATION_QUESTION.questionImageTitle`)}
              type="button"
            >
              <img
                src={fieldImg}
                alt=""
                onClick={() => setSurveyQuestionImageModal(true)}
              />
            </button>
            <button
              type="button"
              title={t(`CUSTOMIZATION_QUESTION.questionSetting`)}
              onClick={() => setSettingQuestionModal(true)}
            >
              <img src={fieldSetting} alt="" />
            </button>
            <button
              type="button"
              title={t(`CUSTOMIZATION_QUESTION.questionDelete`)}
              onClick={() => setDeleteQuestionModal(true)}
            >
              <img src={fieldDelete} alt="" />
            </button>
            <button
              type="button"
              className="drag_icon"
              {...listeners}
              {...attributes}
            >
              <img src={fieldDrag} alt="" />
            </button>
          </div>
        </div>
        <div className="input_field">
          <TextAreaAutoAdjust
            name="question"
            style={{ resize: "none" }}
            onChange={onChangehandler}
            value={data?.question || ""}
            placeholder={t(`CUSTOMIZATION_QUESTION.typeQuestionHere`)}
            maxLength={surveyFormValue?.MAX_TEXT_AREA_LIMIT || 1000}
          />
          <span className="text_count">{`${data?.question?.length || 0}/${
            surveyFormValue?.MAX_TEXT_AREA_LIMIT || 1000
          }`}</span>
        </div>
        {data?.questionImage && (
          <div className="question_image">
            <img
              src={data?.questionImage || picturePLaceholder}
              alt="question file"
            />
            <span onClick={deletedSelectedPicHandler} className="close_button">
              <RxCrossCircled />
            </span>
          </div>
        )}

        <div className="multiSelect cstm_multiselect">
          <div className="input_field">
            <TextAreaAutoAdjust
              disabled
              maxLength={500}
              placeholder={t(`CUSTOMIZATION_QUESTION.questionAnswer`)}
              style={{ resize: "none" }}
              className="has_question_image"
            />
            <span className="text_count">
              {data?.required && !data?.setting?.textAreaMin
                ? `2/${data?.setting?.textAreaMax}`
                : `${data?.setting?.textAreaMin}/${data?.setting?.textAreaMax}`}
            </span>
          </div>
        </div>

        <div className="required__button_field">
          <span className="green">{t(`CUSTOMIZATION_QUESTION.required`)}</span>
          <SwitchButton
            status={data?.required || false}
            onChange={onStatusChangehandler}
          />
        </div>
      </div>

      {/* Delete Selected Modal */}

      {deleteQuestionModal && (
        <DeleteModal
          show={deleteQuestionModal}
          handleClose={closeModal}
          deleteHandler={deletedSelectedQuestionHandler}
          title={`${t(`CUSTOMIZATION_QUESTION.surveyDeleteQuestion`)} ${
            data?.questionNumber + prevQuestionCount
          }?`}
        />
      )}

      {/* Survey Setting Model */}

      {settingQuestionModal && (
        <CustomModal
          className={""}
          handleClose={closeModal}
          show={settingQuestionModal}
        >
          <SurveyQuestionSettingValue
            data={data}
            indexValue={indexValue}
            handleClose={closeModal}
            title={t(`CUSTOMIZATION_QUESTION.answerWordLimit`)}
            selectedBlock={selectedBlock}
            setSurveyQuestionArray={setSurveyQuestionArray}
          />
        </CustomModal>
      )}

      {/* Upload Question Image */}
      {surveyQuestionImageModal && (
        <CustomModal
          show={surveyQuestionImageModal}
          handleClose={closeModal}
          className={""}
          closeButton={false}
        >
          <UploadImage
            type={"question"}
            data={data}
            handleClose={closeModal}
            indexValue={indexValue}
            setSurveyQuestionArray={setSurveyQuestionArray}
            selectedBlock={selectedBlock}
          />
        </CustomModal>
      )}
    </>
  );
};

export default TextFieldQuestion;
